[
  {
    "url": "https://www.linkedin.com/in/[a-zA-Z0-9%._-]+([a-zA-Z0-9=&_/%.-]+)?$",
    "elements": [
      {
        "name": "Full Name",
        "selector": "main h1"
      },
      {
        "name": "Company Name",
        "selector": "button[aria-label] img+span.hoverable-link-text"
      },
      {
        "name": "Title",
        "selector": "a[data-field='experience_company_logo'][href*='linkedin.com/']>div span",
        "within": "main section > #experience ~ div > ul > li",
        "filter": {
          "selector": "div > div:nth-child(2) > div > div span.pvs-entity__caption-wrapper",
          "text": "^(?!.*\\d{4}.*\\d{4}).*$"
        }
      },
      {
        "name": "Title from the list",
        "selector": "main section > #experience ~ div > ul > li:first-child > div > div:nth-child(2) > div:nth-child(2) > ul > li a > div span"
      },
      {
        "name": "Location",
        "selector": "main section > div:nth-child(2) > div:nth-child(2) ul + div span"
      },
      {
        "name": "Current Companies URLs",
        "selector": "a[data-field='experience_company_logo'][href*='linkedin.com/company/']",
        "attributes": ["href"],
        "multiple": "true",
        "within": "main section > #experience ~ div > ul > li",
        "filter": {
          "selector": "div > div:nth-child(2) > div > div span.pvs-entity__caption-wrapper",
          "text": "^(?!.*\\d{4}.*\\d{4}).*$"
        }
      },
      {
        "name": "Experience for scrapping monitor",
        "selector": "#experience"
      },
      {
        "name": "Current Companies URLs for scrapping monitor",
        "selector": "a[data-field='experience_company_logo'][href*='linkedin.com/']",
        "attributes": ["href"],
        "multiple": "true",
        "within": "main section > #experience ~ div > ul > li"
      },
      {
        "name": "Current Companies Names",
        "selector": "div > div:nth-child(2) a[data-field='experience_company_logo'] span:first-of-type:has(+span.t-black--light) > span",
        "multiple": "true",
        "keepEmpty": "true",
        "within": "main section > #experience ~ div > ul > li",
        "filter": {
          "selector": "div > div:nth-child(2) a[data-field='experience_company_logo'] span:nth-child(2) > span",
          "text": "^(?!.*\\d{4}.*\\d{4}).*$"
        }
      },
      {
        "name": "Current Companies Names from lists",
        "selector": "div > div:nth-child(2) > div:first-child:has(+ div > ul > li > span) a[data-field='experience_company_logo'] div.hoverable-link-text > span",
        "multiple": "true",
        "keepEmpty": "true",
        "within": "main section > #experience ~ div > ul > li",
        "filter": {
          "selector": "div > div:nth-child(2) a[data-field='experience_company_logo'] span:nth-child(2) > span",
          "text": "^(?!.*\\d{4}.*\\d{4}).*$"
        }
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/company/",
    "elements": [
      {
        "name": "Company Name",
        "selector": "main h1"
      },
      {
        "name": "Company Website",
        "selector": "main > div:nth-child(1) > section a[target='_blank']:not([href*='linkedin.com/sales/'])",
        "attributes": ["href"]
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/search/results/people/",
    "elements": [
      {
        "name": "Search names",
        "selectors": [
          "div[data-view-name='search-entity-result-universal-template'] span a[href^='https://www.linkedin.com/in/']:not([target])",
          "p a[href^='https://www.linkedin.com/in/'][data-view-name=search-result-lockup-title]",
          "div a[href^='https://www.linkedin.com/in/'][componentKey]"
        ],
        "attributes": ["href"],
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search positions",
        "selectors": [
          "div[data-view-name='search-entity-result-universal-template'] div.t-normal.t-black",
          "div a[href^='https://www.linkedin.com/in/'][componentKey] + div > p[componentKey] + p",
          "div a[href^='https://www.linkedin.com/in/'][componentKey] p:has(a) + div > p"
        ],
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search locations",
        "selectors": [
          "div[data-view-name='search-entity-result-universal-template'] div.t-normal:not(.t-black)",
          "div a[href^='https://www.linkedin.com/in/'][componentKey] + div > p[componentKey] + p + p",
          "div a[href^='https://www.linkedin.com/in/'][componentKey] p:has(a) + div > p + p"
        ],
        "multiple": "true",
        "keepEmpty": "true"
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/search/results/all",
    "elements": [
      {
        "name": "Search names",
        "selectors": [
          "div[data-chameleon-result-urn^='urn:li:member:'] span span a[href^='https://www.linkedin.com/in/']",
          "div[data-testid='lazy-column'] a[href*='linkedin.com/in/'] div:first-child > figure + div > :is(p, div):nth-child(1) a"
        ],
        "multiple": "true",
        "attributes": ["href"],
        "keepEmpty": "true"
      },
      {
        "name": "Search positions",
        "selectors": [
          "div[data-chameleon-result-urn^='urn:li:member:'] div.t-normal.t-black",
          "div[data-testid='lazy-column'] a[href*='linkedin.com/in/'] div:first-child > figure + div > div:nth-child(2) p"
        ],
        "multiple": "true",
        "keepEmpty": "true"
      },
      {
        "name": "Search locations",
        "selectors": [
          "div[data-chameleon-result-urn^='urn:li:member:'] div.t-normal:not(.t-black)",
          "div[data-testid='lazy-column'] a[href*='linkedin.com/in/'] div:first-child > figure + div > div:nth-child(3) p"
        ],
        "multiple": "true",
        "keepEmpty": "true"
      }
    ]
  },
  {
    "url": "https://www.linkedin.com/",
    "elements": [
      {
        "name": "Add paste event listener to linkedin messaging",
        "scenario": {
          "name": "addPasteEventToLinkedInMessenger",
          "container": "div.msg-form__contenteditable"
        }
      }
    ]
  }
]
